import Card from "@/components/Card";

interface Props {
  children?: React.ReactNode;
  className?: string;
  cardTitle: string;
}

function EvaluationCard({
  children,
  className = "flex flex-col",
  cardTitle,
}: Props) {
  return (
    <Card className={className}>
      <p className=" text-lg font-medium text-cool-gray-900 px-6 py-5">
        {cardTitle}
      </p>
      <div className=" flex flex-col border-t border-t-cool-gray-200 border-b border-b-cool-gray-200">
        {children}
      </div>
    </Card>
  );
}

export default EvaluationCard;
